
export interface AttachmentsInterface {
    success: boolean;
    data: AttachmentResponse[];
}

export interface AttachmentInterface {
	success: boolean;
	data: Attachment;
}

export interface AttachmentResponse {
    parent_id: number;
    parent_type_id: number;
    person_id: number;
    attachments: Attachment[];
}

export interface PayloadAttachment {
	parent_id: number;
	parent_type_id: number;
	person_id: number;
	description: string;
	url: string;
}

export interface PayloadAttachmentFilter {
    parent_id: number;
    parent_type_id: number;
    person_id?: number;
		metadata: MetadataInfo[];
}

export interface MetadataInfo {
  type_metadata_id: number;
  value: string
}

export interface Attachment {
	attachment_id: number;
	parent_type_id: number;
	parent_id: number;
	person_id: number;
	person_url_foto: string;
	person_name: string;
	date: string;
	description: string;
	url: string;
}


export const mockAttachment: AttachmentResponse[] = [
	{
		parent_id: 1,
		parent_type_id: 1,
		person_id: 123,
		attachments: [
			{
				attachment_id: 4,
				parent_type_id: 2,
				parent_id: 367,
				person_id: 124,
				person_url_foto: 'images/users_avatar/andres_marin@pragma_com_co_REDONDA.png',
				person_name: 'Julián David Gamboa Roa',
				date: "2024-02-28",
				description: "This is a mock attachment.",
				url: "https://www.google.com"
			},
			{
				attachment_id: 3,
				parent_type_id: 2,
				parent_id: 366,
				person_id: 1851,
				person_url_foto: 'images/users_avatar/andres_marin@pragma_com_co_REDONDA.png',
				person_name: 'Julián David Gamboa Roa',
				date: "2024-02-28",
				description: "Mi auto valoracion.",
				url: "https://www.google.com"
			}
		]
	}
];